/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { CreateLocationBody } from '../types';
// @ts-ignore
import type { Location } from '../types';
// @ts-ignore
import type { UpdateLocationBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new Location.
         * @summary Create a Location
         * @param {string} dashboardId 
         * @param {CreateLocationBody} [createLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (dashboardId: string, createLocationBody?: CreateLocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('createLocation', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/locations`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a Location.
         * @summary Delete an exising Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a Location.
         * @summary Find Location by ID
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocation', 'locationId', locationId)
            const localVarPath = `/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Locations for a Dashboard.
         * @summary List all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLocationsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/locations`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLocationsForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/locations`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorders all Locations for a Dashboard.
         * @summary Reorder all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLocationsForDashboard: async (dashboardId: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('reorderLocationsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/locations/order`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a Location.
         * @summary Update an existing Location
         * @param {string} locationId 
         * @param {UpdateLocationBody} [updateLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (locationId: string, updateLocationBody?: UpdateLocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            const localVarPath = `/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new Location.
         * @summary Create a Location
         * @param {string} dashboardId 
         * @param {CreateLocationBody} [createLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(dashboardId: string, createLocationBody?: CreateLocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(dashboardId, createLocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a Location.
         * @summary Delete an exising Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a Location.
         * @summary Find Location by ID
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all Locations for a Dashboard.
         * @summary List all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Location>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Location>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationsForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reorders all Locations for a Dashboard.
         * @summary Reorder all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderLocationsForDashboard(dashboardId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderLocationsForDashboard(dashboardId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.reorderLocationsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a Location.
         * @summary Update an existing Location
         * @param {string} locationId 
         * @param {UpdateLocationBody} [updateLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(locationId: string, updateLocationBody?: UpdateLocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(locationId, updateLocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Creates a new Location.
         * @summary Create a Location
         * @param {string} dashboardId 
         * @param {CreateLocationBody} [createLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(dashboardId: string, createLocationBody?: CreateLocationBody, options?: RawAxiosRequestConfig): AxiosPromise<Location> {
            return localVarFp.createLocation(dashboardId, createLocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a Location.
         * @summary Delete an exising Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(locationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a Location.
         * @summary Find Location by ID
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(locationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Location> {
            return localVarFp.getLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Locations for a Dashboard.
         * @summary List all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Location>> {
            return localVarFp.getLocationsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Location>> {
            return localVarFp.getLocationsForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorders all Locations for a Dashboard.
         * @summary Reorder all Locations for Dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLocationsForDashboard(dashboardId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderLocationsForDashboard(dashboardId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a Location.
         * @summary Update an existing Location
         * @param {string} locationId 
         * @param {UpdateLocationBody} [updateLocationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(locationId: string, updateLocationBody?: UpdateLocationBody, options?: RawAxiosRequestConfig): AxiosPromise<Location> {
            return localVarFp.updateLocation(locationId, updateLocationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Creates a new Location.
     * @summary Create a Location
     * @param {string} dashboardId 
     * @param {CreateLocationBody} [createLocationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public createLocation(dashboardId: string, createLocationBody?: CreateLocationBody, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).createLocation(dashboardId, createLocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a Location.
     * @summary Delete an exising Location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public deleteLocation(locationId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).deleteLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a Location.
     * @summary Find Location by ID
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocation(locationId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Locations for a Dashboard.
     * @summary List all Locations for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Locations for a published Dashboard.
     * @summary List all Locations for published Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationsForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorders all Locations for a Dashboard.
     * @summary Reorder all Locations for Dashboard by ID
     * @param {string} dashboardId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public reorderLocationsForDashboard(dashboardId: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).reorderLocationsForDashboard(dashboardId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a Location.
     * @summary Update an existing Location
     * @param {string} locationId 
     * @param {UpdateLocationBody} [updateLocationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public updateLocation(locationId: string, updateLocationBody?: UpdateLocationBody, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).updateLocation(locationId, updateLocationBody, options).then((request) => request(this.axios, this.basePath));
    }
}

